/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetUserCouponPaymentsOptions,
  GetUserCouponPaymentsResponses,
} from '../types/GetUserCouponPayments'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary List coupon payments for a user
 * {@link /v1/user/:user_id/coupon_payments}
 */
export function getUserCouponPayments<ThrowOnError extends boolean = true>(
  options: Options<GetUserCouponPaymentsOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetUserCouponPaymentsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/user/{user_id}/coupon_payments',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetUserCouponPaymentsResponses, ThrowOnError>>,
  )
}
